import React, { Component, Fragment } from 'react';
import * as HMS from "../../../../common/component/Index";
import * as Func from "../../../../../../helpers/functions";
import { Input, Tabs, message } from 'antd';
import Wrapper from './../../../../common/component/Wrapper/index';
import RichTextEditor, { ClassicEditor } from './../../../../common/component/RichTextEditor/index';
import { UPLOAD_DIRECTORY } from '../../../../../../constants/Define';

const { TabPane } = Tabs

export default class PackageRateDesc extends Component {
    constructor(props) {
        super(props);
        this.state = {
          activeKey: "0"
        };
    }

    componentDidMount() {
      const { match } = this.props;
      match.params.id && this.props.getPackageRateTranslate(match.params.id);
    }

    handleChangeInfoTab = activeKey => {
      this.setState({ activeKey });
    };

    handleEditInfoTab = (targetKey, action) => {
      switch (action) {
        case "add":
          this.handleAddInfoTab();
          break;
        case "remove":
          this.handleRemoveInfoTab(targetKey);
          break;
        default:
          break;
      }
    };

    handleAddInfoTab = () => {
      const { extraInfos } = this.props.PackageRate;
      extraInfos.push({ 
          title: 'Nội dung mới', 
          content: ''
      });
      this.props.onChange('extraInfos', extraInfos);
      this.setState({ 
        activeKey: (extraInfos.length - 1).toString()
      });
    };
  
    handleRemoveInfoTab = targetKey => {
      const extraInfos = [...this.props.PackageRate.extraInfos];
      const indexDelele = parseInt(targetKey);
  
      if(extraInfos.length <= 1) {
          return message.error('Phải giữ ít nhất một bài viết !');
      }
  
      if(!!extraInfos[indexDelele].content) {
          return message.error('Không thể xoá bài viết đang có nội dung!');
      }
  
      extraInfos.splice(indexDelele, 1);
      this.setState({ 
          activeKey: (indexDelele > 0 ? indexDelele - 1 : indexDelele).toString() 
      });
      this.props.onChange('extraInfos', extraInfos);
    };
  
    onChangeContent = (field, value, index) => {
      const extraInfos = [...this.props.PackageRate.extraInfos];
      extraInfos[index][field] = value.trimLeft();
      this.props.onChange('extraInfos', extraInfos);
    }

    render() {
        const { t, validation, PackageRate, disabled } = this.props;

        return (
          <div className="basic-info">
            <div className="basic-info-box">
              <div className="col-md-12 mb-4">
                <h4>{t("item.packageRate.productPackageDetail")}</h4>
              </div>

              <Wrapper className="col-md-12">
                <HMS.FormWrapperInputComponent
                  isRequired={true}
                  isValidation={true}
                  dataValidation={PackageRate.title}
                  validation={validation.title}
                  labelTitle={t(`item.packageRate.titleDesc`)}
                >
                  <Input
                    placeholder=""
                    type={`text`}
                    className={`form-control`}
                    name={`title`}
                    maxLength={100}
                    onChange={(e) =>
                      this.props.onChange("title", e.target.value)
                    }
                    value={Func.checkUndefine(PackageRate.title)}
                    disabled={disabled}
                  />
                </HMS.FormWrapperInputComponent>
              </Wrapper>

              <Wrapper className="col-md-12">
                <Tabs
                  onChange={this.handleChangeInfoTab}
                  activeKey={this.state.activeKey}
                  className="tab-extra-infos"
                  type="editable-card"
                  onEdit={this.handleEditInfoTab}
                  disabled={disabled}
                >
                  {PackageRate.extraInfos &&
                    PackageRate.extraInfos.map((info, index) => (
                      <TabPane
                        tab={
                          <span
                            className={`tab-content ${
                              validation.extraInfos[index] &&
                              (validation.extraInfos[index].title ||
                                validation.extraInfos[index].content)
                                ? "is-errors"
                                : ""
                            }`}
                          >
                            {info.title}
                          </span>
                        }
                        key={index}
                      >
                        <Wrapper className="col-md-6">
                          <HMS.FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={info.title}
                            validation={validation.extraInfos[index]?.title}
                            labelTitle={t(`item.packageRate.titleContent`)}
                          >
                            <Input
                              placeholder=""
                              type={`text`}
                              className={`form-control`}
                              name={`title`}
                              onChange={(e) =>
                                this.onChangeContent(
                                  "title",
                                  e.target.value,
                                  index
                                )
                              }
                              value={Func.checkUndefine(info.title)}
                              disabled={disabled}
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-12">
                          <HMS.FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={info.content}
                            validation={validation.extraInfos[index]?.content}
                            labelTitle={t(`item.packageRate.content`)}
                          >
                            <RichTextEditor
                              editor={ClassicEditor}
                              data={info.content || ""}
                              config={{
                                uploadDirectory: UPLOAD_DIRECTORY.IMAGES,
                              }}
                              onChange={(event, editor) => {
                                const value = editor.getData();
                                return this.onChangeContent(
                                  "content",
                                  value,
                                  index
                                );
                              }}
                              disabled={disabled}
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                      </TabPane>
                    ))}
                </Tabs>
              </Wrapper>
            </div>
          </div>
        );
    }
}
